<template>
  <div
    class="flex flex-col gap-1 rounded-lg border px-4 py-3 dark:border-slate-600"
  >
    <div class="flex items-start gap-3">
      <div class="flex min-w-0 flex-1 flex-col gap-1">
        <div class="flex flex-wrap items-center gap-2">
          <span class="font-semibold">
            {{ $h.formatCurrency(payment.amount) }}
          </span>
          <span class="text-gray-600 capitalize-first dark:text-gray-300">
            {{ $t(`enums.invoicing.mode.${payment.payment_mode}`) }}
          </span>
          <span
            class="inline-flex items-center rounded-md bg-green-50 px-2 py-0.5 text-xs font-medium text-green-700 capitalize-first ring-1 ring-green-600/20 ring-inset"
          >
            {{ $t('global.invoicing_type.' + payment.invoice_type) }}
          </span>
        </div>
        <span class="text-sm text-gray-500">{{ payment.emission_date }}</span>
      </div>
      <BaseDeleteButton
        v-if="$can('manage_invoicing')"
        icon="trash"
        :tooltip="$t('button.delete_m', { var: $t('attributes.payment') })"
        @click="deleteThisPayment"
      />
    </div>

    <div class="flex flex-col text-sm">
      <p v-if="payment.recipient" class="capitalize-first">
        {{ $t('attributes.received_by') }}:
        <span class="font-medium">{{ payment.recipient.full_name }}</span>
      </p>
      <template v-if="payment.payment_mode === 'CHE'">
        <p class="capitalize-first">
          {{ $t('attributes.check_number') }}:
          <span class="font-medium">{{ payment.check_number }}</span>
        </p>
        <p class="capitalize-first">
          {{ $t('attributes.bank_name') }}:
          <span class="font-medium">{{ cBankName }}</span>
        </p>
      </template>
      <p v-if="payment.comment" class="capitalize-first">
        {{ $t('attributes.complementary_info') }}:
        <span class="font-medium">{{ payment.comment }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'InvoiceItemEditDialogItem',
  props: {
    payment: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({ metadata: 'invoicing/getInvoiceMetadata' }),
    cBankName() {
      return this.payment.issuing_bank
        ? this.metadata.bank.find(
            (el) => el.id === parseInt(this.payment.issuing_bank)
          ).name
        : ''
    }
  },
  methods: {
    ...mapActions({ deletePayment: 'invoicing/deletePayment' }),
    deleteThisPayment() {
      if (!window.confirm(this.$t('global.confirm_delete_payment'))) return
      this.deletePayment({ payment_id: this.payment.id }).then(() => {
        this.$h.toastSuccess(
          this.$t('toasts.deleted_m', { var: this.$t('attributes.payment') })
        )
      })
    }
  }
}
</script>
